(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["finelith-steps"] && !Shopify.designMode) return;
  try {
    
/* Empty: JS is inlined above to scope by section id */

  } catch(e) { console.error(e); }
})();
})();
